@if (showSeeAllButton() && url()) {
  <a [href]="url()" [class.disabled]="disabled()">
    <div class="see-all">
      <app-button
        [ariaLabel]="seeAllText() | translate "
        [preventDef]="false"
        icon="icon-ArrowRight"
        [buttonStyleType]="BUTTON_TYPES.SEE_ALL"
      >{{ seeAllText() | translate }}
      </app-button>
    </div>
  </a>
}

@if (showSeeAllButton() && (contentType() || contentType() === 0) && relatedId()) {
  <a [class.disabled]="disabled()" [routerLink]="[relatedUrl()]" [queryParams]="relatedParams()">
    <div class="see-all">
      <app-button
        [ariaLabel]="seeAllText() | translate "
        [preventDef]="false"
        icon="icon-ArrowRight"
        [buttonStyleType]="BUTTON_TYPES.SEE_ALL"
      >{{ seeAllText() | translate }}
      </app-button>
    </div>
  </a>
}
